<div class="wrapper">
	<app-header [showMenu]="false"></app-header>
	<app-announcement-modal></app-announcement-modal>
	<div class="page-container">
		<mat-sidenav-container>
			<router-outlet></router-outlet>
		</mat-sidenav-container>
	</div>
	<app-footer></app-footer>
</div>
